<template>
  <div class="text-item" :class="{active: selected}">
    <div class="text">{{title.slice(0,2)}}</div>
    <div class="text">{{title.slice(-2)}}</div>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      default: false,
      type: Boolean,
    },
    title: {
      default: "",
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
.text-item {
  min-width: 47px;
  max-width: 47px;
  height: 47px;
  color: white;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(90, 90, 90, 1);
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.active {
  border: rgba(200, 200, 200, 1) solid 2px;
}
</style>